import { render, staticRenderFns } from "./ScreenAuth.vue?vue&type=template&id=bb65f744"
import script from "./ScreenAuth.vue?vue&type=script&lang=js"
export * from "./ScreenAuth.vue?vue&type=script&lang=js"
import style0 from "./ScreenAuth.vue?vue&type=style&index=0&id=bb65f744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports